import {EnableSidebar, PageTitle} from '../../../_metronic/layout/core'
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {ChartsWidgetGeneral, ChartsWidgetGeneralBar} from '../../../_metronic/partials/widgets'
import {Vertical} from '../../modules/wizards/components/Vertical'
import {getOrganization as getOrganization} from '../organization/list/core/_requests'
import {getSurveyType as getSurveyType} from '../surveytype/list/core/_requests'
import {getApplicationRole as getApplicationRole} from '../applicationrole/list/core/_requests'
import {CustomGetDashboardSurveyInfo} from '../survey/list/core/_requests'
import {getSemester as getSemester} from '../semester/list/core/_requests'
import './Hide.css'
import {useAuth} from '../../modules/auth'
import {StudentSurveyBox} from './StudentSurveyBox'
import {TeacherAndStaffSurveyBox} from './TeacherAndStaffSurveyBox'
import MyScheduleComponent from '../../modules/exam/MyExamScheduleTeacher'
import MySeatScheduleComponent from '../../modules/exam/MyExamScheduleStudent'
import {Link, useNavigate} from 'react-router-dom'
import SurveyFeedbackDashboardBox from './components/SurveyFeedbackDashboardBox'
import axios from 'axios'
import {GraduateCardBox} from './GraduateCardBox'
import {fetchGraduateProfile} from '../CustomController'
import {useModule} from '../../platform/modules'

const API_URL = process.env.REACT_APP_API_URL
const GET_STUDENT_SCHEDULE_URL = `${API_URL}/Custom/GetStudentSchedule`
const GET_INSTRUCTOR_SCHEDULE_URL = `${API_URL}/Custom/GetInstructorSchedule`
const GET_STUDENT_ONLINE_ATTENDANCE_STATUS_URL = `${API_URL}/Custom/GetStudentOnlineAttendanceStatus`
const JOIN_STUDENT_ONLINE_ATTENDANCE_URL = `${API_URL}/Custom/JoinOnlineAttendance`

const react_app_title = process.env.REACT_APP_TITLE

interface StudentAttendancePayload {
  hasAttendance: boolean
  attendance?: {
    sessionId: number
    courseName: string
    remainingSeconds: number
    isPresent: boolean
    isLockedByInstructor: boolean
  }
}

type DashboardSection = 'lessons' | 'exams'

const DashboardPage = () => {
  const intl = useIntl()
  const [organizations, setorganizations] = React.useState([])
  const [showbutton, setShowbutton] = React.useState(false)
  const [organizations2, setorganizations2] = React.useState<Array<number>>([])
  const [organizations3, setorganizations3] = React.useState<Array<string>>([])
  const [surveytypes, setsurveytypes] = React.useState([])
  const [semesters, setsemesters] = React.useState([])
  const [applicationroles, setapplicationroles] = React.useState([])
  //document?.getElementById("kt_header")?.classList.add("hide");
  const {currentUser} = useAuth()
  const {isModuleSession} = useModule()
  const [hasStudentSchedule, setHasStudentSchedule] = useState(false)
  const [hasInstructorSchedule, setHasInstructorSchedule] = useState(false)
  const [isGraduate, setIsGraduate] = useState(false)
  const [showAttendanceModal, setShowAttendanceModal] = useState(false)
  const [attendancePollCount, setAttendancePollCount] = useState(0)
  const [attendanceInfo, setAttendanceInfo] = useState<StudentAttendancePayload | null>(null)
  const [attendanceLoading, setAttendanceLoading] = useState(false)
  const [dashboardSection, setDashboardSection] = useState<DashboardSection>('lessons')

  useEffect(() => {
    console.log(currentUser)
    /*getOrganization(
      'items_per_page=99999&filter_rOrganizationId=notnull',
      'Id,Name,Student*Id',
      'Student'
    ).then((res: any) => {
      setorganizations(
        res.data.map((a: any) => {
          return {value: a?.studentId.length, label: a?.name}
        }) || []
      )
    })*/
    /*getSurveyType('items_per_page=99999', 'Id,Name,Survey*Id', 'Survey').then((res: any) => {
      setsurveytypes(
        res.data.map((a: any) => {
          return {value: a?.surveyId.length, label: a?.name}
        }) || []
        )
    })*/
    /*getApplicationRole(
      'items_per_page=99999',
      'Id,Name,ApplicationUserRole*ApplicationRoleId',
      'ApplicationUserRole'
    ).then((res: any) => {
      setapplicationroles(
        res.data.map((a: any) => {
          return {value: a?.applicationUserRoleApplicationRoleId.length, label: a?.name}
        }) || []
      )
    })*/
    /*getSemester('items_per_page=99999', 'Id,Name,SemesterCourse*Id', 'SemesterCourse').then(
      (res: any) => {
        setsemesters(
          res.data.map((a: any) => {
            return {value: a?.semesterCourseId.length, label: a?.name}
          }) || []
        )
      }
      )*/

    CustomGetDashboardSurveyInfo().then((res: any) => {
      if (res.data === '1') setShowbutton(false)
      else setShowbutton(false)
    })
  }, [currentUser])

  useEffect(() => {
    if (react_app_title !== 'ykys' || currentUser?.roleName !== 'STUDENT') {
      setIsGraduate(false)
      return
    }

    fetchGraduateProfile()
      .then((res) => {
        setIsGraduate(!!res.data?.isGraduate)
      })
      .catch(() => {
        setIsGraduate(false)
      })
  }, [currentUser?.id, currentUser?.roleName])

  useEffect(() => {
    if (currentUser?.roleName === 'STUDENT') {
      axios
        .get(GET_STUDENT_SCHEDULE_URL)
        .then((res) => {
          if (res.data.semesterStart) {
            setHasStudentSchedule(true)
          }
        })
        .catch(() => {})
    }
    if (currentUser?.roleName === 'TEACHER') {
      axios
        .get(GET_INSTRUCTOR_SCHEDULE_URL)
        .then((res) => {
          if (res.data.semesterStart) {
            setHasInstructorSchedule(true)
          }
        })
        .catch(() => {})
    }
  }, [currentUser])

  useEffect(() => {
    if (!showAttendanceModal || currentUser?.roleName !== 'STUDENT') {
      return
    }

    const pollAttendance = () => {
      setAttendanceLoading(true)
      axios
        .get(GET_STUDENT_ONLINE_ATTENDANCE_STATUS_URL)
        .then((res) => setAttendanceInfo(res.data as StudentAttendancePayload))
        .finally(() => setAttendanceLoading(false))
    }

    pollAttendance()

    const interval = setInterval(() => {
      setAttendancePollCount((prev) => {
        const next = prev + 1
        if (next >= 18) {
          setShowAttendanceModal(false)
          setAttendanceInfo(null)
          return 0
        }
        return next
      })
      pollAttendance()
    }, 10000)

    return () => clearInterval(interval)
  }, [showAttendanceModal, currentUser?.roleName])

  const joinAttendance = () => {
    if (!attendanceInfo?.attendance?.sessionId) {
      return
    }

    setAttendanceLoading(true)
    axios
      .post(JOIN_STUDENT_ONLINE_ATTENDANCE_URL, {sessionId: attendanceInfo.attendance.sessionId})
      .then(() => axios.get(GET_STUDENT_ONLINE_ATTENDANCE_STATUS_URL))
      .then((res) => setAttendanceInfo(res.data as StudentAttendancePayload))
      .finally(() => setAttendanceLoading(false))
  }

  /*useEffect(() => {
    setorganizations2(organizations.map((a: any) => a.value))
    setorganizations3(organizations.map((a: any) => a.label))
  }, [organizations])

  console.log(currentUser)*/

  return (
    <>
      <div>
        <>
          {currentUser?.roleName === 'sonradegistir' ? (
            <>
              {' '}
              {surveytypes.length > 0 &&
                (surveytypes.map((a: any) => a.value).length > 10 ? (
                  <div className='mb-7 col-12'>
                    <ChartsWidgetGeneralBar
                      className='1'
                      title={intl.formatMessage({id: 'SurveyType.STATS'})}
                      series={surveytypes.map((a: any) => a.value)}
                      labels={surveytypes.map((a: any) => a.label)}
                      name='Survey.COUNT'
                    />
                  </div>
                ) : (
                  <div className='mb-7 col-4'>
                    <ChartsWidgetGeneral
                      className='1'
                      title={intl.formatMessage({id: 'SurveyType.STATS'})}
                      series={surveytypes.map((a: any) => a.value)}
                      labels={surveytypes.map((a: any) => a.label)}
                    />
                  </div>
                ))}
              {applicationroles.length > 0 &&
                (applicationroles.map((a: any) => a.value).length > 10 ? (
                  <div className='mb-7 col-12'>
                    <ChartsWidgetGeneralBar
                      className='2'
                      title={intl.formatMessage({id: 'ApplicationRole.STATS'})}
                      series={applicationroles.map((a: any) => a.value)}
                      labels={applicationroles.map((a: any) => a.label)}
                      name='ApplicationUserRole.COUNT'
                    />
                  </div>
                ) : (
                  <div className='mb-7 col-4'>
                    <ChartsWidgetGeneral
                      className='2'
                      title={intl.formatMessage({id: 'ApplicationRole.STATS'})}
                      series={applicationroles.map((a: any) => a.value)}
                      labels={applicationroles.map((a: any) => a.label)}
                    />
                  </div>
                ))}
              {semesters.length > 0 &&
                (semesters.map((a: any) => a.value).length > 10 ? (
                  <div className='mb-7 col-12'>
                    <ChartsWidgetGeneralBar
                      className=''
                      title={intl.formatMessage({id: 'Semester.STATS'})}
                      series={semesters.map((a: any) => a.value)}
                      labels={semesters.map((a: any) => a.label)}
                      name='SemesterCourse.COUNT'
                    />
                  </div>
                ) : (
                  <div className='mb-7 col-4'>
                    <ChartsWidgetGeneral
                      className=''
                      title={intl.formatMessage({id: 'Semester.STATS'})}
                      series={semesters.map((a: any) => a.value)}
                      labels={semesters.map((a: any) => a.label)}
                    />
                  </div>
                ))}
              {organizations2.length > 0 &&
                organizations3.length > 0 &&
                (organizations.map((a: any) => a.value).length > 10 ? (
                  <div className='mb-7 col-12'>
                    <ChartsWidgetGeneralBar
                      className='3'
                      title={intl.formatMessage({id: 'Organization.Student.STATS'})}
                      series={organizations2}
                      labels={organizations3}
                      name='Student.COUNT'
                    />
                  </div>
                ) : (
                  organizations2 &&
                  organizations3 && (
                    <div className={`mb-7 col-4 ${organizations.map((a: any) => a.value).length}`}>
                      <ChartsWidgetGeneral
                        className='3'
                        title={intl.formatMessage({id: 'Organization.Student.STATS'})}
                        series={organizations2}
                        labels={organizations3}
                      />
                    </div>
                  )
                ))}{' '}
            </>
          ) : null}
        </>

        {react_app_title === 'ykys' && currentUser?.roleName === 'TEACHER' ? (
          <SurveyFeedbackDashboardBox />
        ) : null}
        {react_app_title === 'ykys' && currentUser?.roleName === 'STUDENT' && !isGraduate ? (
          <StudentSurveyBox />
        ) : null}
        {react_app_title === 'dsos' &&
          (currentUser?.roleName === 'STUDENT' || currentUser?.roleName === 'TEACHER') && (
            <div className='dashboard-mode-switch mb-6'>
              <button
                type='button'
                className={`btn btn-lg ${
                  dashboardSection === 'lessons' ? 'btn-primary' : 'btn-light-primary'
                }`}
                onClick={() => setDashboardSection('lessons')}
              >
                <i className='bi bi-journal-text fs-2 me-2'></i>
                Dersler
              </button>
              <button
                type='button'
                className={`btn btn-lg ${
                  dashboardSection === 'exams' ? 'btn-primary' : 'btn-light-primary'
                }`}
                onClick={() => setDashboardSection('exams')}
              >
                <i className='bi bi-clipboard-check fs-2 me-2'></i>
                Sınavlar
              </button>
              {currentUser?.roleName === 'TEACHER' && (
                <Link to='/my-exam-duty-archive' className='btn btn-lg btn-light-primary'>
                  <i className='bi bi-archive fs-2 me-2'></i>
                  Görev Arşivim
                </Link>
              )}
            </div>
          )}

        {currentUser?.roleName === 'STUDENT' && react_app_title !== 'dsos' && (
          <div className='mb-5 d-flex flex-wrap gap-3'>
            <button
              className='btn btn-primary'
              onClick={() => {
                setAttendancePollCount(0)
                setAttendanceInfo(null)
                setShowAttendanceModal(true)
              }}
            >
              Yoklamaya Katıl
            </button>
            <Link to='/student-clearance-request' className='btn btn-light-primary'>
              Ilisik Kesme Basvurusu
            </Link>
          </div>
        )}

        {react_app_title === 'dsos' &&
          currentUser?.roleName === 'STUDENT' &&
          dashboardSection === 'lessons' && (
            <div className='dashboard-section-card mb-5'>
              <div className='d-flex flex-wrap align-items-center gap-3'>
                <button
                  className='btn btn-primary'
                  onClick={() => {
                    setAttendancePollCount(0)
                    setAttendanceInfo(null)
                    setShowAttendanceModal(true)
                  }}
                >
                  Canlı Ders Yoklamasına Katıl
                </button>
                {hasStudentSchedule && (
                  <Link to='/my-student-schedule' className='btn btn-light-primary'>
                    Ders Programım
                  </Link>
                )}
              </div>
            </div>
          )}
        {react_app_title === 'ykys' && currentUser?.roleName === 'STUDENT' && isGraduate ? (
          <GraduateCardBox />
        ) : null}
        {!isModuleSession && react_app_title !== 'dsos' && currentUser?.roleName === 'TEACHER' && (
          <div className='mb-5'>
            <Link to='/question-requests/incoming' className='btn btn-light-primary'>
              Tarafıma Gönderilen Soru Talepleri
            </Link>
          </div>
        )}
        {react_app_title === 'dsos' &&
          hasInstructorSchedule &&
          currentUser?.roleName === 'TEACHER' &&
          dashboardSection === 'lessons' && (
            <div className='dashboard-section-card mb-5'>
              <Link to='/my-instructor-schedule' className='btn btn-primary'>
                Ders Programım
              </Link>
            </div>
          )}
        {react_app_title === 'ykys' &&
        (currentUser?.roleName === 'TEACHER' || currentUser?.roleName === 'USER') ? (
          <TeacherAndStaffSurveyBox />
        ) : null}
        {react_app_title === 'dsos' &&
        currentUser?.roleName === 'TEACHER' &&
        dashboardSection === 'exams' ? (
          <MyScheduleComponent />
        ) : null}
        {react_app_title === 'dsos' &&
        currentUser?.roleName === 'STUDENT' &&
        dashboardSection === 'exams' ? (
          <MySeatScheduleComponent />
        ) : null}

        {showAttendanceModal && currentUser?.roleName === 'STUDENT' && (
          <div className='modal d-block' role='dialog'>
            <div className='modal-dialog modal-dialog-centered'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h5 className='modal-title'>Çevrimiçi Yoklama</h5>
                  <button
                    type='button'
                    className='btn-close'
                    onClick={() => {
                      setShowAttendanceModal(false)
                      setAttendancePollCount(0)
                    }}
                  ></button>
                </div>
                <div className='modal-body'>
                  <div className='text-muted small mb-2'>
                    Sorgulanıyor ... ({attendancePollCount}/18)
                  </div>
                  {attendanceInfo?.hasAttendance && attendanceInfo.attendance ? (
                    <>
                      <div className='fw-bold'>{attendanceInfo.attendance.courseName}</div>
                      <div className='mb-3'>
                        Kalan süre: {attendanceInfo.attendance.remainingSeconds} sn
                      </div>
                      {!attendanceInfo.attendance.isLockedByInstructor &&
                        !attendanceInfo.attendance.isPresent && (
                          <button className='btn btn-success' onClick={joinAttendance}>
                            Buradayım
                          </button>
                        )}
                      {attendanceInfo.attendance.isPresent && (
                        <div className='badge bg-success'>Katılımınız alındı</div>
                      )}
                      {attendanceInfo.attendance.isLockedByInstructor && (
                        <div className='badge bg-secondary'>Öğretim üyesi kilidi aktif</div>
                      )}
                    </>
                  ) : (
                    <div className='alert alert-warning mb-0'>
                      Katılınacak bir yoklama bulunamadı.
                    </div>
                  )}
                  {attendanceLoading && <div className='text-muted mt-2'>Yükleniyor...</div>}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export {DashboardPage}
